import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}
export function Button({
  children,
  href,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-sage hover:bg-sage-hover rounded-full transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-y-0.5';
  if (href) {
    return <a href={href} onClick={onClick as React.MouseEventHandler<HTMLAnchorElement>} className={`${baseStyles} ${className}`} data-id="element-249">
        {children}
      </a>;
  }
  return <button onClick={onClick as React.MouseEventHandler<HTMLButtonElement>} className={`${baseStyles} ${className}`} {...props} data-id="element-250">
      {children}
    </button>;
}